import * as progression from "./progression";

declare function getLogging(): any;
declare const DEVELOPER_CONFIG: string | undefined;
declare const FORCE_LOGGING: boolean | undefined;

const instance = getLogging();

const GAME_ID = 625;
export const PRODUCTION = process.env.NODE_ENV === "production";

export const LEVEL_TITLE = -1;
export const LEVEL_SELECT = -2;
export const LEVEL_CREDITS = -3;
export const LEVEL_CONGRATULATIONS = -4;

enum Version {
    BETA_DEVEL      = 0,
    BETA_1          = 1000,
    // BETA_2       = 1100, etc
    FRIENDS_1       = 2000,
    NEWGROUNDS_1    = 3000,
    KONGREGATE_1    = 77777770,
}

enum Developer {
    RELEASE = 0,
    JOEL    = 1,
    MICHAEL = 2,
    TOMASZ  = 3,
    DAVID   = 4,
    CRYSTAL = 5,
    YUHAN   = 6,
}

export enum Action {
    // Player jumped
    Jump          = 1,
    // Clicked, but didn't drag far enough to begin cut
    PreCut        = 2,
    // Started drawing cut
    StartCut      = 3,
    // Finished drawing cut
    DrewCut       = 4,
    // Finished drawing cut, but was invalid
    InvalidCut    = 5,
    // Started sliding a side
    StartSlide    = 6,
    // Finished sliding a side
    FinishSlide   = 7,
    // Slid platforms into the boundary
    SlideMaxRange = 8,
    // Done cutting, closed
    FinishCut     = 9,
    // Attempt to cancel a cut
    CancelCut     = 10,
    // Canceled a cut
    CanceledCut   = 11,
    // Reset the level
    Reset         = 12,
    // Player landed on new platform
    NewPlatform   = 13,
    // A cut was undone (either by player or by death rewind)
    UndoCut       = 14,

    FallingDeath  = 20,
    SpikeDeath    = 21,
    LaserDeath    = 22,

    // The player hit the undo button
    UndoButton    = 23,

    // Record data about level end
    Finish        = 24,

    // Reset level select screen
    ResetLevels   = 25,
    ChangeLanguage= 26,
    // Log the language used at startup
    CurrentLanguage=27,
    TutorialPhase = 28,
}

let DEVELOPER = Developer.RELEASE;
console.info("Developer:", DEVELOPER_CONFIG);
switch (DEVELOPER_CONFIG) {
case "joel":
    DEVELOPER = Developer.JOEL;
    break;
case "michael":
    DEVELOPER = Developer.MICHAEL;
    break;
case "tomasz":
    DEVELOPER = Developer.TOMASZ;
    break;
case "david":
    DEVELOPER = Developer.DAVID;
    break;
case "crystal":
    DEVELOPER = Developer.CRYSTAL;
    break;
case "yuhan":
    DEVELOPER = Developer.YUHAN;
    break;
default:
    DEVELOPER = Developer.RELEASE;
}

const VERSION = Version.KONGREGATE_1 + DEVELOPER;

export function initialize() {
    console.info("Production build: ", PRODUCTION);
    console.info("Game version: ", VERSION);
    console.info("Logging disabled.");
}

export function startLevel(questId: number, questDetail: any) {
}

export function logAction(action: Action, actionDetail?: any) {
}

export function finishLevel() {
}



// WEBPACK FOOTER //
// ./src/logging.ts